/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { QueryBuilder } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { RootStoreType } from "./index"


/**
 * RouteTimelineViolationDtoBase
 * auto generated base class for the model RouteTimelineViolationDtoModel.
 */
export const RouteTimelineViolationDtoModelBase = ModelBase
  .named('RouteTimelineViolationDto')
  .props({
    __typename: types.optional(types.literal("RouteTimelineViolationDto"), "RouteTimelineViolationDto"),
    id: types.identifier,
    routeSolutionId: types.union(types.undefined, types.integer),
    type: types.union(types.undefined, types.string),
    name: types.union(types.undefined, types.string),
    value: types.union(types.undefined, types.null, types.number),
    createdOn: types.union(types.undefined, types.string),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class RouteTimelineViolationDtoModelSelector extends QueryBuilder {
  get id() { return this.__attr(`id`) }
  get routeSolutionId() { return this.__attr(`routeSolutionId`) }
  get type() { return this.__attr(`type`) }
  get name() { return this.__attr(`name`) }
  get value() { return this.__attr(`value`) }
  get createdOn() { return this.__attr(`createdOn`) }
}
export function selectFromRouteTimelineViolationDto() {
  return new RouteTimelineViolationDtoModelSelector()
}

export const routeTimelineViolationDtoModelPrimitives = selectFromRouteTimelineViolationDto().routeSolutionId.type.name.value.createdOn
